import { Component, input } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { IconDirective } from 'common/icon/icon.directive';
import { ButtonDirective } from 'common/button/button.directive';

@Component({
  selector: 'comp-dialog-header',
  templateUrl: 'dialog-header.component.html',
  styleUrls: ['dialog-header.component.scss'],
  imports: [MatDialogClose, IconDirective, ButtonDirective],
})
export class DialogHeaderComponent {
  readonly showCloseIcon = input<boolean>(true);
  /**
   * Value the header close icon closes the dialog with, via `mat-dialog-close`.
   * Callers such as the confirm dialog bind `false` so the icon behaves
   * exactly like a cancel action instead of the default `undefined` result.
   */
  readonly closeIconValue = input<unknown>(undefined);
}
